export function modGroupCanBeDeemphasized(minSelectable, mustBeAlwaysSentModCount, selectedByDefaultModCount) {
    return selectedByDefaultModCount + mustBeAlwaysSentModCount >= minSelectable;
}
// Don't specify the return type so that we can infer with ReturnType<> and use as an "enum"
// oxlint-disable-next-line typescript/explicit-function-return-type
export function menuItemFieldNamesThatCanBeCopiedToOtherModels() {
    const fieldNames = [
        'name',
        'description',
        'fulfillmentName',
        'story',
        'category',
        'taxationStatus',
        'taxProfileId',
        'badges',
        'images',
        'priceOptionCategory',
        'displayStyle',
        'useFullScreenCustomizationFlow',
        'buildYourOwnBaseImage',
        'assortedBaseImage',
        'isRetail',
        'instructions',
        'prepTimeMinutes',
        'denormalizeModGroups',
        'deemphasizeButtonImage',
    ];
    return fieldNames;
}
// Don't specify the return type so that we can infer with ReturnType<> and use as an "enum"
// oxlint-disable-next-line typescript/explicit-function-return-type
export function modFieldNamesThatCanBeCopiedToOtherModels() {
    const fieldNames = [
        'name',
        'description',
        'fulfillmentName',
        'taxationStatus',
        'taxProfileId',
        'badges',
        'images',
        'syncMultiplePriceOptions',
        'instructions',
        'prepTimeMinutes',
    ];
    return fieldNames;
}
// Don't specify the return type so that we can infer with ReturnType<> and use as an "enum"
// oxlint-disable-next-line typescript/explicit-function-return-type
export function modGroupFieldNamesThatCanBeCopiedToOtherModels() {
    const fieldNames = [
        'name',
        'description',
        'fulfillmentName',
        'images',
        'posMinSelectableOverride',
        'posMaxSelectableOverride',
        'hideFromMenu',
        'deemphasize',
        'useAsComboBuilder',
        'isComboDecision',
        'showAsCollapsed',
        'columnCount',
        'prependPlusSignBeforeModPrices',
        'allowMultipleOfSameAddon',
        'disableAllowMultipleOfSameAddon',
        'virtualSubGroups',
        'posMinAggregateQuantityOverride',
        'posMaxAggregateQuantityOverride',
        'minChoiceQuantity',
        'maxChoiceQuantity',
        'choiceQuantityIncrement',
        'hideAggregateSelectionCriteria',
        'hideChoiceSelectionCriteria',
        'hideSelectionCriteria',
        'hideWalletSelectionCriteria',
        'items',
        'displayStyle',
    ];
    return fieldNames;
}
//# sourceMappingURL=menu_rules.js.map